import { render, staticRenderFns } from "./DriverAuthorizationManagement.vue?vue&type=template&id=b2a429fe&scoped=true&"
import script from "./DriverAuthorizationManagement.vue?vue&type=script&lang=js&"
export * from "./DriverAuthorizationManagement.vue?vue&type=script&lang=js&"
import style0 from "./DriverAuthorizationManagement.vue?vue&type=style&index=0&id=b2a429fe&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a429fe",
  null
  
)

export default component.exports